import { useEffect } from "react";
import "@/App.css";

function App() {
  useEffect(() => {
    window.location.replace("/salem.html");
  }, []);

  return (
    <div className="App" data-testid="redirect-root" style={{ minHeight: "100vh", background: "#043927" }} />
  );
}

export default App;
